module.exports = __webpack_public_path__ + "static/media/learning-16.584149db.png";